import React, { Component } from 'react';
import api from "../../api";
import ChatHistory from './chatHistory'
import AdminLayout from "../../components/adminLayout";
import Loader from "../../components/Loader";
import { Row, Col, Button, Accordion, Card, FormControl, Form } from 'react-bootstrap'
import axios from 'axios'
export default class Engage extends Component {
    constructor(props) {
        super(props);
            // Recieving Params
    const query = new URLSearchParams(this.props.location.search);
    const rec_fb_page_id = query.get("fb_page_id");
    const rec_biz_id = query.get("biz_id");
    this.state = {
        biz:{},
        biz_id: rec_biz_id,
        fb_page_id: rec_fb_page_id,
        queries: [],
        loading: false,
        fb_token:"EAAEATwX9nZAgBAAcZB1JU1KABpzcAfinx2RSX5ZA9JSgKxGZAAQ3uKpR3D2l60BAMl8WwA93L9sDMKk6EUZC5v32SzTBnYrWWKRKG7eRZALZCcKo7fQdDm5DVn5LZBP19dmDsZBVZBOd3RKUbxpHEZAA1JYorWQrhpkmNGMGkXJvxFHXDZBaV84g0hoeOEruy66GupYZD"
      };
      this.respondInput = React.createRef()
      this.onChangeResponse = this.onChangeResponse.bind(this);
        
        this.ChatHistory = ChatHistory.bind(this)
    }
    componentDidMount = async () => {
        this.setState({ loading: true })
        let payload = {recipient:this.state.fb_page_id,resolved:false}
        await api.postService('chat/get/custom',payload).then(queries => {
            console.log("queries:",queries)
            this.setState({
                queries: queries.data.data,
                loading: false,
            })
        });
        this.loadBizData(this.state.biz_id);
    }

    
  loadBizData = async (biz_id) => {
    api.getService(`/business/${biz_id}`).then(
      (res) => {
        console.log("Business:", res);
        let data = res.data.data;
        this.setState({ biz: data });
      },
      (error) => {
        console.log("error", error);
      }
    );
  };

    onChangeResponse(e){
        const id = parseInt(e.target.id)
        const response_text = e.target.value.toString()
        this.state.queries[id].reply = response_text
    }

    handleResponse = async (id) => {
        this.setState({ loading: true })

        const fb_api = `https://graph.facebook.com/v6.0/me/messages?access_token=${this.state.biz.fb_token}`
        axios.post(fb_api, 
            {
                "messaging_type": "RESPONSE",
                "recipient": {
                    "id": this.state.queries[id].sender
                },
                "message": {
                    "text": this.state.queries[id].reply
                }
            }
        )
        // .then(response => {
        //     console.log("response:",response)
        //     this.setState({
        //         loading: false,
        //     })
        // })

        let payload = {
            "reply": this.state.queries[id].reply,
            "resolved": true
        }
        await api.putService(`chat/${this.state.queries[id]._id}`,payload)
        .then(res => {
            console.log("res:",res);
            this.setState({loading:false});
        })

    }


    
    render() {
        const queries = this.state.queries
        return (
            <AdminLayout>
                  {this.state.loading ? <Loader /> : ""}
                <Row className="gs-inner-container right-border-radius flex-fill scrollable">
                    <Col className="p-0 m-2 ">

                    <div className="gs-container">
                <Accordion defaultActiveKey="0">
                    {queries.map((item,index) =>
                        <Card>
                            <Accordion.Toggle as={Card.Header} variant="link" eventKey={index}>
                                Q{index}: {item.query.substr(0,40)}... 
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={index}>
                                <Card.Body>
                                When: {(item.query_time).toLocaleString()}<br/>
                                From: {item?.sender}<br/>
                                <br/>
                                {item.query}
                                <br/><br/>
                                    <Row className="p-2">
                                        <Col sm="auto">
                                            <Button
                                                // className={"navbar-button"}
                                                size='sm'
                                                variant="primary"
                                                onClick={ () => this.handleResponse(index)}
                                            >
                                                Respond
                                            </Button>
                                        </Col>
                                        <Col>

                                            <FormControl 
                                                        id = { index.toString()}
                                                        placeholder ={item.reply}
                                                        as="textarea" aria-label="Respond" 
                                                        onChange={this.onChangeResponse}
                                            />
                                        </Col>
                                    </Row>
                                    {item.reply_time === undefined? "": "Responded at " + item.reply_time}
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    
                    )}
                </Accordion>
            </div>

                    {/* <ChatHistory/> */}
                        {/* <Tabs defaultActiveKey="Trivia" id="uncontrolled-engageTabs">
                            <Tab eventKey="OpenQueries" title="Open Queries">
                              
                            </Tab>
                            <Tab eventKey="Trivia" title="Trivia">
                                <Trivia/>
                            </Tab>
                        </Tabs> */}

                    </Col>
                </Row>
            </AdminLayout>
        )
    }
}